import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllLanguagesList } from '../API/services/alkymersService';
import { languagesList } from '../components/DropdownLanguage/DropdownLanguage';
import { setLanguagesAvailable } from '../redux/actions/testGroupCreatorActions';

export const useLanguageTranslations = () => {
  const dispatch = useDispatch();
  const { languagesAvailable } = useSelector((state) => state.testGroups);

  const getLanguagesList = async () => {
    try {
      const languages = await getAllLanguagesList();
      return languages.map((l) => ({
        ...l,
        label: l.displayName,
        value: l.code,
      }));
    } catch (e) {
      console.error(`Error fetching languages: ${e}`);
      return [...languagesList, { label: 'Aleman', value: 'u', iso: 'DEU' }];
    }
  };

  useEffect(() => {
    const fetchLanguages = async () => {
      const list = await getLanguagesList();
      dispatch(setLanguagesAvailable(list));
    };

    if (languagesAvailable.length < 1) {
      fetchLanguages();
    }
  }, []);

  return {
    testGroupLanguageList: languagesAvailable,
  };
};
